<template>
  <div id="add-receipt">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'Tạo phiếu xuất', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter pb-5">
      <block :nobody="true" ref="breceipt" class="soft-control">
        <!-- <b-row align-v="center" class="text-center">
          <b-col><h3 class="mt-3">Báo giá mới</h3></b-col>
        </b-row>
        <hr /> -->
        <b-row class="mx-0" align-h="center">
          <b-col md="10 px-0 border-right border-info">
            <b-card class="m-3">
              <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
                <form role="form" @submit.prevent="handleSubmit(doSave)">
                  <b-row>
                    <b-col>
                      <base-input
                        :disabled="receipt.id != ''"
                        v-model="receipt.code"
                        label="Mã phiếu xuất"
                        placeholder="Không xuất hệ thống sẽ tự phát sinh"
                      >
                      </base-input>
                    </b-col>
                    <b-col>
                      <div>
                        <label for="datepicker-lg">Ngày tạo</label>
                        <b-form-datepicker
                          :disabled="receipt.id != ''"
                          id="datepicker-lg"
                          :date-format-options="{
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                          }"
                          v-model="receipt.date"
                          locale="vi"
                        ></b-form-datepicker>
                      </div>
                    </b-col>
                    <b-col>
                      <base-input label="Người Tạo" readonly value="xxxx"> </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <base-select
                          :disabled="receipt.id != ''"
                          v-model="receipt.customer"
                          label="Mã khách hàng"
                          :ajaxData="getCustomer"
                          :error="errors[0]"
                        >
                          <template v-slot:selected="{ item }">
                            <div>
                              {{ item.code }}
                            </div>
                          </template>
                          <template v-slot:body="{ item }">
                            <div>
                              <strong>{{ item.code }}</strong> <br />
                              <span>{{ item.name }}</span>
                            </div>
                          </template>
                        </base-select>
                      </ValidationProvider>
                    </b-col>
                    <b-col md="4">
                      <base-select
                        :disabled="receipt.id != ''"
                        v-model="receipt.customer"
                        label="Tên khách hàng"
                        :ajaxData="getCustomer"
                        ><template v-slot:selected="{ item }">
                          <div>
                            {{ item.name }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </b-col>
                    <b-col md="4">
                      <base-select
                        :disabled="receipt.id != ''"
                        v-model="receipt.customer"
                        label="Email khách hàng"
                        :ajaxData="getCustomer"
                        ><template v-slot:selected="{ item }">
                          <div>
                            {{ item.email }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </b-col>
                  </b-row>
                </form>
              </ValidationObserver>
              <hr />
              <span> Đặt thù khách hàng : {{ receipt.customer.fax }} </span>
              <hr />
              <table v-if="manufacture && manufacture.id" class="table soft-table">
                <thead>
                  <tr>
                    <td>
                      Mã đơn hàng : <b>{{ manufacture.order.code }}</b>
                    </td>
                    <td>
                      Mã lệnh chế tạo :
                      <b>{{ manufacture.code }}</b>
                    </td>
                  </tr>
                </thead>
              </table>
              <hr />
              <div class="d-flex">
                <h5>* Sản phẩm :</h5>
                <!-- <b-button
                  v-if="receipt.id == ''"
                  @click="productReceiptAddRow"
                  variant="success px-1 py-0 ml-2 mb-2"
                >
                  <i class="fa fa-flus" aria-hidden="true"></i> Thêm 1 dòng
                </b-button> -->
              </div>
              <base-table :data="receiptBillDetails">
                <template slot="columns">
                  <th>STT</th>
                  <th>Mã sản phẩm</th>
                  <th>Tên sản phẩm</th>
                  <th>Quy cách</th>
                  <th>Chiều dài</th>
                  <th>Hệ màu</th>
                  <th>Màu sắc</th>
                  <th>Mã màu 1</th>
                  <th>Mã màu 2</th>
                  <th>Số lượng</th>
                  <th>Đơn giá</th>
                  <th>Thành tiền</th>
                  <th>Thuế</th>
                  <th>Thành tiền sau thuế</th>
                  <th>Ghi chú</th>
                  <th></th>
                </template>

                <template slot-scope="{ row, index }">
                  <tr v-if="!row.edit" :key="index">
                    <td class="bg-info text-light col-fix ">
                      {{ index + 1 }}
                    </td>
                    <td>{{ row.product.code }}</td>
                    <td>
                      {{ row.product.name }}
                      <!-- <span v-if="row.productCustom != ''"><br />{{ row.productCustom }}</span> -->
                      <span v-if="row.reason"><br />{{ row.reason.name }}</span>
                    </td>
                    <td class="text-center">{{ row.productSpecify.name }}mm</td>
                    <td>
                      {{ row.length }}
                    </td>
                    <td>
                      <span v-if="row.color">{{ row.color.label }}</span>
                    </td>
                    <td>
                      {{ row.colorText }}
                    </td>
                    <td>
                      {{ row.colorCode1 }}
                    </td>
                    <td>
                      {{ row.colorCode2 }}
                    </td>
                    <td class="text-right">{{ $formatNumber(row.quantity) }} {{ row.unit }}</td>
                    <td class="text-right">{{ $formatNumber(row.price) }} {{ row.currency }}</td>
                    <td class="text-right">
                      {{ $formatNumber(row.quantity * row.price) }}
                      {{ row.currency }}
                    </td>
                    <td class="text-right">
                      <span v-if="row.tax > 0"> {{ row.tax }} % </span>
                      <span v-else>
                        không thuế
                      </span>
                    </td>
                    <td class="text-right">
                      {{ $formatNumber(row.quantity * row.price + (row.quantity * row.price * row.tax) / 100) }}
                      {{ row.currency }}
                    </td>
                    <td v-html="row.note"></td>
                    <td></td>
                  </tr>
                  <tr v-else :key="'' + index">
                    <td class="bg-info text-light col-fix text-center">
                      {{ index + 1 }}
                    </td>
                    <td class="p-1">
                      <base-select
                        style="max-width:130px"
                        @change="productChange(row)"
                        v-model="row.product"
                        :ajaxData="getProduct"
                        placeholder="Xuất mã hoặc tên sản phẩm"
                        :error="!row.product || !row.product.id"
                      >
                        <template v-slot:selected="{ item }">
                          <div>
                            {{ item.code }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </td>
                    <td class="p-1">
                      <span v-if="row.product">
                        {{ row.product.name }}
                        <!-- <span v-if="row.productCustom != ''"><br />{{ row.productCustom }}</span> -->
                        <span v-if="row.reason"><br />{{ row.reason.name }}</span>
                      </span>
                    </td>
                    <td class="p-1">
                      <base-select
                        style="width:100px"
                        @change="productSpecifyChange(row)"
                        v-if="row.product && row.product.id"
                        v-model="row.productSpecify"
                        :options="row.product.productSpecifys"
                        :error="!row.productSpecify || !row.productSpecify.id"
                      >
                        <template v-slot:selected="{ item }">
                          <div>{{ item.name }} mm</div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <span>{{ item.name }} mm</span>
                          </div>
                        </template>
                      </base-select>
                      <span v-else>--Vui lòng chọn sản phẩm--</span>
                    </td>
                    <td>
                      <base-input v-model="row.length"> </base-input>
                    </td>
                    <td class="p-1">
                      <color
                        @change="productColorChange(row)"
                        :error="!row.color || !row.color.id"
                        v-model="row.color"
                      ></color>
                    </td>
                    <td>
                      <base-input v-model="row.colorText"> </base-input>
                    </td>
                    <td>
                      <base-input v-model="row.colorCode1"> </base-input>
                    </td>
                    <td>
                      <base-input v-model="row.colorCode2"> </base-input>
                    </td>
                    <td class="p-1" style="min-width:150px;">
                      <div class="d-flex">
                        <base-input
                          :valid="row.quantity <= row.productInfo.quantity"
                          :mask="'number'"
                          v-model="row.quantity"
                        >
                        </base-input>
                        <span style="vertical-align: middle; align-self: center; margin-left: 5px; margin-top: -8px;">
                          {{ $ucWord(row.unit) }}
                        </span>
                      </div>
                    </td>
                    <td class="p-1" style="min-width:150px;">
                      <div class="d-flex">
                        <base-input readonly :mask="'number'" v-model="row.price"> </base-input>
                        <span style="vertical-align: middle; align-self: center; margin-left: 5px; margin-top: -8px;">
                          {{ row.currency }}
                        </span>
                      </div>
                    </td>
                    <td class="p-1 " style="min-width:140px">
                      <div class="d-flex">
                        <base-input readonly :mask="'number'" :value="row.price * row.quantity"> </base-input>
                        <span style="vertical-align: middle; align-self: center; margin-left: 5px; margin-top: -8px;">
                          {{ row.currency }}
                        </span>
                      </div>
                    </td>
                    <td class="p-1 " style="min-width:140px">
                      <base-select readonly v-model="row.tax" :options="['10', '8', '0']">
                        <template v-slot:selected="{ item }">
                          <div v-if="item > 0">
                            <strong>{{ item }}</strong> %
                          </div>
                          <div v-else>
                            <strong>Không chịu thuế</strong>
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div v-if="item > 0">
                            <strong>{{ item }}</strong> %
                          </div>
                          <div v-else>
                            <strong>Không chịu thuế</strong>
                          </div>
                        </template>
                      </base-select>
                    </td>
                    <td class="p-1" style="min-width:160px">
                      <base-input
                        readonly
                        :value="$formatNumber(row.price * row.quantity + (row.price * row.quantity * row.tax) / 100)"
                      >
                      </base-input>
                    </td>
                    <td class="p-1" style="min-width:450px">
                      <base-input v-model="row.note"> </base-input>
                    </td>
                    <td class="col-fix text-center">
                      <div class="d-flex">
                        <!-- <b-button
                          class="mr-2"
                          variant="outline-danger px-1 py-0"
                          @click="productReceiptDeleteRow(index, row)"
                        >
                          <i class="fa fa-backspace" aria-hidden="true"></i>
                        </b-button> -->
                      </div>
                    </td>
                  </tr>
                </template>
              </base-table>
              <hr />

              <base-input label="Số kiện hàng" v-model="receipt.package"></base-input>

              <div class="form-group" style="overflow: hidden;">
                <label class="form-control-label" for="">Ghi chú</label>
                <ckeditor :editor="editor" v-model="receipt.note" @ready="onReady" :config="editorConfig"></ckeditor>
              </div>
            </b-card>
          </b-col>
          <b-col md="2 px-0">
            <b-card class="m-3 sticky-top">
              <b-row>
                <b-col xl="12" v-if="!dontSave" class="mb-2">
                  <b-button @click="handleSave" :disabled="receipt.id != ''" variant="success" block>
                    <i class="fa fa-save" aria-hidden="true"></i>
                    {{ receipt.id != '' ? 'Đã lưu phiếu' : 'Lưu phiếu' }}
                  </b-button>
                </b-col>
                <b-col xl="12" v-if="!dontSave" class="mb-2">
                  <b-button @click="doPrint" variant="primary" block>
                    <i class="fa fa-print" aria-hidden="true"></i>
                    In phiếu
                  </b-button>
                </b-col>
                <b-col xl="12">
                  <b-button @click="doBack" block>
                    <i class="fa fa-long-arrow-alt-left" aria-hidden="true"></i>
                    Trở về
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </block>
      <preview @doSave="handleSaveFromPreview" ref="preview"></preview>
    </div>
  </div>
</template>
<script>
import { customerService, productService, orderService, receiptService } from '@/_services';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';

import Preview from './__PreviewOut';

export default {
  name: 'receipt-add-out',
  components: {
    ckeditor: CKEditor.component,
    Preview
  },
  data() {
    return {
      receiptBillDetails: [],
      receipt: {
        id: '',
        code: '',
        customer: '',
        poCode: '',
        date: new Date(),
        note: ''
      },
      dontSave: false,
      manufacture: {},
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          'heading',
          '|',
          'fontSize',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'bold',
          'italic',
          'link',
          'underline',
          'strikethrough',
          '|',
          'alignment',
          'bulletedList',
          'numberedList',
          'blockQuote',
          '|',
          'indent',
          'outdent',
          'link',
          'insertTable',
          'tableColumn',
          'tableRow',
          'mergeTableCells'
        ]
      },
      order: {},
      back: -1
    };
  },
  created() {},
  mounted() {
    var self = this;
    if (this.$route.query.order) {
      orderService.findOrderReceipt(self.$route.query.order).then(res => {
        debugger;
        let order = res.data;
        let oldReceiptBillDetails = order.receiptBillDetails;
        let orderDetails = this.verifyProductSelect(order.orderDetails);
        this.order = order;

        orderDetails.forEach(element => {
          self.checkQuantity(element, oldReceiptBillDetails);
        });

        // let quantity = 0;
        // if (quantityProduce >= manufacture.quantityProduce) {
        //   quantity = manufacture.quantityProduce;
        //   var self = this;
        //   this.dontSave = true;
        //   this.$swal({
        //     title: "Lỗi xuất kho",
        //     text: "Số lượng sản xuất ra đã xuất kho",
        //     confirmButtonText: "OK",
        //     reverseButtons: true
        //   }).then(function(result) {
        //     if (result.value) {
        //       self.$router.go(self.back);
        //     }
        //   });
        // } else {
        //   quantity = manufacture.quantityProduce - quantityProduce;
        // }
        self.receipt.customerContact = order.customerContact;
        self.receipt.receiverContact = order.receiverContact;
        self.receipt.receiver = order.receiver;
        self.receipt.poCode = order.poCode;
        self.receipt.customer = order.customer;
      });
    }
  },
  methods: {
    fetchData() {},
    verifyProductSelect(orderDetails) {
      let arrTmp = [];
      let arrProductSelect = this.$route.query.product;
      if (!Array.isArray(arrProductSelect)) {
        arrProductSelect = [arrProductSelect];
      }
      for (let i = 0; i < arrProductSelect.length; i++) {
        const element = arrProductSelect[i];
        orderDetails.forEach(item => {
          if (element == item.id) {
            arrTmp.push(item);
          }
        });
      }
      return arrTmp;
    },
    checkQuantity(orderDetail, oldReceiptBillDetails) {
      let quantity = 0;
      let quantityExport = 0;
      for (let i = 0; i < oldReceiptBillDetails.length; i++) {
        const element = oldReceiptBillDetails[i];
        if (
          orderDetail.productInfo &&
          element.productInfo.id == orderDetail.productInfo.id &&
          element.orderDetailId == orderDetail.id
        ) {
          quantityExport += element.quantity;
        }
      }

      if (quantityExport <= orderDetail.quantity) {
        if (orderDetail.productInfo && orderDetail.productInfo.quantity > 0) {
          quantity = orderDetail.quantity - quantityExport;
          quantity = quantity < orderDetail.productInfo.quantity ? quantity : orderDetail.productInfo.quantity;

          // let unitHank = orderDetail.productSpecify.unitHank;

          // let countHank = Math.floor(quantity / unitHank);
          // let slodd = quantity - countHank * unitHank;
          // let countBag = Math.ceil(quantity / orderDetail.productSpecify.unitBag);

          let unitSack = orderDetail.productSpecify.unitSack;

          let countSack = Math.floor(quantity / unitSack);
          let slodd = quantity - countSack * unitSack;
          // let countSack = Math.ceil(quantity / orderDetail.productSpecify.unitSack);
          let note = '';
          if(quantity < unitSack){
            note = '1 K';
          }else{
            note = ` ${countSack} K x ${unitSack} ${orderDetail.unit} + ${slodd} ${orderDetail.unit} = ${countSack} K`;
          }
          this.receiptBillDetails.push({
            product: orderDetail.product,
            orderDetailId: orderDetail.id,
            poCode: orderDetail.poCode,
            productCustom: orderDetail.productCustom,
            reason: orderDetail.reason,
            reasonId: orderDetail.reasonId,
            color: orderDetail.color,
            colorCode1: orderDetail.colorCode,
            colorCode2: orderDetail.colorCode2,
            productSpecify: orderDetail.productSpecify,
            productInfo: orderDetail.productInfo,
            quantity: quantity,
            price: orderDetail.price,
            unit: orderDetail.unit,
            tax: orderDetail.tax,
            currency: orderDetail.currency,
            total: orderDetail.price * quantity,
            order: {
              poCode: this.order.poCode,
              id: this.order.id,
              customer: this.order.customer,
              customerContact: this.order.customerContact
            },
            length: orderDetail.length,
            colorText: orderDetail.colorText,
            // colorCode: orderDetail.colorCode,
            note: note,
            edit: true
          });
        }
      }
    },
    getCustomer(keyword, cb) {
      customerService.findAll({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    getProduct(keyword, cb) {
      productService.findAll({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    productReceiptAddRow() {
      this.receiptBillDetails.push({
        product: '',
        color: '',
        colorCode1: '',
        colorCode2: '',
        gramMet: 0,
        metKg: 0,
        gramHank: 0,
        unit: 'sợi',
        length: 0,
        totalKgWrap: 0,
        position: '',
        productSpecify: '',
        quantity: 0,
        price: 0,
        tax: 0,
        edit: true
      });
    },
    productReceiptDeleteRow(index, item) {
      if (item.edit) {
        this.receiptBillDetails.splice(index, 1);
      } else {
        this.$swal({
          title: 'Bạn có chắc thực hiện thao tác này?',
          text: 'Bạn sẽ không thể hoàn nguyên điều này!!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Không',
          reverseButtons: true
        }).then(function(result) {
          if (result.value) {
            alert('contact dev');
          }
        });
      }
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    validateReceipt() {
      var self = this;
      return new Promise(async (resolve, reject) => {
        let validate = await self.$refs.csInfo.validate();
        for (let i = 0; i < self.receiptBillDetails.length; i++) {
          const element = self.receiptBillDetails[i];
          if (element.quantity > element.productInfo.quantity) {
            validate = false;
          }
        }
        if (validate) {
          resolve();
        } else {
          reject();
        }
      });
    },
    async handleSave() {
      await this.validateReceipt()
        .then(async () => {
          await this.doSave();
        })
        .catch(() => {
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    async handleSaveFromPreview(cb) {
      await this.validateReceipt()
        .then(async () => {
          await this.doSave();
          cb();
        })
        .catch(() => {
          cb();
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    productChange(row) {
      row.productSpecify = '';
      row.price = 0;
      row.loaded = false;
    },
    productSpecifyChange() {},
    productColorChange() {},
    handelChoosePrice(price) {
      if (this.receiptBillDetailselect) this.receiptBillDetailselect.price = price;
    },
    doSave() {
      let receipt = Object.assign({}, this.receipt);
      receipt.customer = {
        id: this.receipt.customer.id
      };
      let receiptBillDetails = [];
      this.receiptBillDetails.forEach(element => {
        let tmp = Object.assign({}, element);
        tmp.product = {
          id: element.product.id
        };
        tmp.order = {
          id: element.order.id
        };
        tmp.productInfo = {
          id: element.productInfo.id
        };
        tmp.productSpecify = {
          id: element.productSpecify.id
        };
        tmp.total = tmp.quantity * tmp.price;
        receiptBillDetails.push(tmp);
      });
      this.$refs.breceipt.block();
      let order = {
        id: this.order.id
      };
      receiptService
        .createOut(receipt, receiptBillDetails, order)
        .then(res => {
          this.$alertify.success(res.message, {
            duration: 4000
          });
          this.receipt.id = res.data.id;
          this.receipt.code = res.data.code;
          this.receiptBillDetails.forEach(element => {
            element.edit = false;
          });
        })
        .finally(() => {
          this.$refs.breceipt.unBlock();
        });
    },
    doPrint() {
      this.validateReceipt()
        .then(() => {
          this.$refs.preview.visible = true;
          this.$refs.preview.setData(this.receipt, this.receiptBillDetails);
        })
        .catch(() => {
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    doBack() {
      var self = this;
      this.$swal({
        title: 'Bạn có chắc thực hiện thao tác này?',
        text: 'Những thao tác bạn vừa thực hiện sẽ không được lưu lại',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Không',
        reverseButtons: true
      }).then(function(result) {
        if (result.value) {
          self.$router.go(self.back);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.ck-editor__editable {
  min-height: 150px;
}
#add-receipt {
  .soft-control {
    .b-table-sticky-header {
      // height: 500px;
      // max-height: 500px;
    }
  }
}
</style>
